import { type ReactNode } from 'react';
import { RepositoryContext } from './RepositoryContext.js';
import type { Repositories } from './RepositoryInterfaces.js';

export const RepositoryProvider = ({ children, repositories }: { children: ReactNode; repositories: Repositories }) => (
  <RepositoryContext.Provider value={repositories}>{children}</RepositoryContext.Provider>
);
